/**
 * @class CSVDoc
 */
class CSVDoc {
  /**
   *
   * @param {Object} params
   * @param {number} columns - The number of columns to use
   * @param {string} [deliminator] - Set the character to use between cells (Default: ',')
   */
  constructor({ columns, deliminator = ',' }) {
    this.columns = columns;
    this.deliminator = deliminator;
    this.rows = [];
  }

  addRow(...args) {
    this.rows.push(args);
    return this;
  }

  toString() {
    return this.rows
      .map(row => {
        const newRow = [];
        for (let i = 0; i < this.columns; i++) {
          newRow.push(this.escapeCell(row[i]));
        }
        return newRow.join(this.deliminator);
      })
      .join('\n');
  }

  escapeCell(v) {
    if (typeof v === 'string' && v.indexOf(this.deliminator) >= 0) {
      return '"' + v.replace(/"/g, '""') + '"';
    }

    return v;
  }

  download(filename) {
    const url = 'data:text/csv,\ufeff' + encodeURIComponent(this.toString());
    const link = document.createElement('a');
    link.style.display = 'none';
    link.href = url;
    link.setAttribute('download', filename);
    if (typeof link.download === 'undefined') {
      link.setAttribute('target', '_blank');
    }
    document.body.appendChild(link);
    link.click();
    setTimeout(() => {
      document.body.removeChild(link);
    }, 1000);
    return this;
  }
}

export default CSVDoc;
